var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.61837,0,0,1.61837,-144.842,-195.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.59,
    cy: 417.03,
    rx: 72.24,
    ry: 8.78,
    style: {
      fill: "rgb(15,152,247)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 189.59,
    cy: 417.03,
    rx: 72.24,
    ry: 8.78,
    style: {
      fill: "white",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,417C339.08,419.42 322.95,421.38 303.08,421.38C283.21,421.38 267.08,419.38 267.08,417C267.08,414.62 283.2,412.63 303.08,412.63C322.96,412.63 339.08,414.62 339.08,417Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.08,417C339.08,419.42 322.95,421.38 303.08,421.38C283.21,421.38 267.08,419.38 267.08,417C267.08,414.62 283.2,412.63 303.08,412.63C322.96,412.63 339.08,414.62 339.08,417Z",
    style: {
      fill: "white",
      fillOpacity: 0.5,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,127.79C204,127.79 198.41,123.4 192,125.59C185.59,127.78 180.73,138.46 179,147.14C177.27,155.82 170.62,162.4 172.22,172.58C173.82,182.76 185.39,184.35 199.36,185.85C213.33,187.35 220.91,185.65 227.49,176.47C234.07,167.29 231.28,156.12 227.39,146.24C223.5,136.36 217.02,127.19 211.63,125.49C206.24,123.79 204,127.79 204,127.79Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,180C181.843,180.424 182.824,180.759 183.83,181",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.6,134.9C200.322,139.99 197.434,144.785 194,149.18C188.28,156.53 175.63,163.47 174.82,171.18C174.557,173.267 175.202,175.37 176.59,176.95",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81,171.77C225.397,172.738 224.866,173.651 224.23,174.49",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,152.45C221,152.45 227.43,159.87 226.81,167.79",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.38,130.81C196.299,130.293 191.271,132.275 187.91,136.12C187.68,136.38 187.47,136.64 187.27,136.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.49,319.3L163.24,338.54C163.24,338.54 157.92,364.35 156.24,374.99C154.56,385.63 151.48,401.81 150.92,401.81C150.36,401.81 141.18,407.36 138.24,411.89C135.3,416.42 139.03,418.34 143.11,416.89C147.19,415.44 152.73,411.34 154.54,406.47C156.35,401.6 157.25,399.79 157.37,399C157.49,398.21 176.84,346.26 178.76,340.71C180.68,335.16 184.76,318.86 184.76,318.86L194.27,286.6C194.27,286.6 204.45,319.77 204.57,321.24C204.69,322.71 215.09,407.49 215.57,410.66C216.05,413.83 215.91,416.09 217.83,416.77C219.75,417.45 224.28,417.45 226.66,417.45C229.04,417.45 237.3,418.7 241.37,417.68C245.44,416.66 245.9,415.98 243.07,413.94C240.24,411.9 224.52,410.6 223.07,404.66C222.95,404.21 222.84,316.94 222.84,316.94C222.84,316.94 221.48,288.08 219.22,279.94L166.92,279.94L164.49,319.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,416.87C147.17,415.39 152.72,411.32 154.53,406.45L154.91,405.45C152.6,407.91 148.91,411.33 148.91,411.33C148.684,410.17 148.179,409.082 147.44,408.16C146.784,407.436 145.778,407.131 144.83,407.37L148.83,402.97C145.83,404.83 140.43,408.63 138.31,411.9C135.28,416.41 139,418.34 143.1,416.87Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,413.92C241.06,412.53 233.09,411.48 227.77,409.05C227.551,409.237 227.379,409.473 227.27,409.74C226.932,410.699 226.668,411.681 226.48,412.68L215.48,410.33L215.48,410.64C215.93,413.81 215.82,416.07 217.74,416.75C219.66,417.43 224.19,417.43 226.57,417.43C228.95,417.43 237.21,418.68 241.28,417.66C245.35,416.64 245.87,416 243,413.92Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,233C179.73,233 174.54,235.39 168.26,246.67C161.39,258.98 162.57,265.82 162.47,280.67C162.37,295.52 162.07,320.17 162.07,320.17C162.07,320.17 181.07,325.26 194.7,324.46C208.33,323.66 225.62,320.57 225.62,320.57C225.62,320.57 221.93,270.29 218.44,255.83C214.95,241.37 212.85,234.83 212.85,234.83C206.105,235.766 199.27,235.867 192.5,235.13C180.93,234 179.73,233 179.73,233Z",
    style: {
      fill: "rgb(38,50,56)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.59,277.47C202.11,279.18 202.59,280.91 203.01,282.64",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.54,249.17C193.568,256.603 197.025,264.332 199.88,272.29",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.12,223.44C306.52,223.04 296.69,221.5 296.69,221.5L294.77,220.71C294.77,220.71 306.67,221.66 306.77,221.16C306.87,220.66 307.27,220.06 306.47,219.96C305.67,219.86 290.36,216.75 290.36,216.75C290.36,216.75 294.25,213.07 294.75,212.27C295.25,211.47 295.94,209.87 295.14,209.87C294.34,209.87 294.14,210.37 293.05,211.07C291.96,211.77 287.66,213.47 286.46,214.46C285.26,215.45 281.68,218.05 281.68,218.05L240.1,212.33C240.1,212.33 225.5,194.33 222.33,190.49C220.126,187.927 217.618,185.644 214.86,183.69C211.8,182.34 211.86,184.6 211.86,184.6L218.25,213C218.25,213 234.78,222.85 235.8,222.85C236.82,222.85 281.48,224.33 281.48,224.33C281.48,224.33 284.48,225.73 286.36,226.92C288.24,228.11 300.23,231.92 300.23,231.92C300.23,231.92 301.03,231.52 300.13,230.82C299.23,230.12 293.45,227.33 293.45,227.33L305.45,229.93C305.45,229.93 306.15,229.43 305.85,228.93C305.55,228.43 294.85,224.34 294.85,224.34L306.85,224.94C306.85,224.94 307.71,223.84 307.12,223.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.59,209.24C233.28,203.93 224.67,193.33 222.33,190.49C220.126,187.927 217.618,185.644 214.86,183.69C211.8,182.34 211.86,184.6 211.86,184.6L218.25,213C218.25,213 225.71,217.44 230.91,220.36L237.59,209.24Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,181.26C193.4,181.26 184.72,181.66 179.4,187.55C174.08,193.44 174.71,206.4 176.91,214.18C179.11,221.96 181.91,226.25 181.3,228.95C180.69,231.65 178.51,232.54 179.7,235.03C180.89,237.52 187.78,240.22 199.95,239.82C212.12,239.42 214.42,236.82 214.52,234.54C214.62,232.26 213.72,230.35 214.02,228.95C214.32,227.55 223.1,219.77 223.1,211.19C223.1,202.61 219.31,199.62 218.41,193.43C217.51,187.24 217.81,186.35 214.12,183.65C210.43,180.95 198.29,179.56 193.4,181.26Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.46,211C186.559,213.428 183.339,215.446 179.89,217",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,212C190.42,212 188.27,218.94 183,222.77",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.96,187.54L212.96,197.12L208.76,192.23L211.96,187.54Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.37,197.92L211.96,187.54L206.87,182.06L206.37,197.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6,164.3C196.472,167.759 196.905,171.313 196.89,174.88C196.861,177.19 196.627,179.492 196.19,181.76L206.37,197.92L209.26,182.92L211.16,172.54C211.16,172.54 199.59,171.88 195.6,164.3Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.77,189.24L206.37,197.92L203.38,193.23L205.77,189.24Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.8,181.36L202.08,198.02L205.77,189.24L195.9,175.67L192.8,181.36Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.17,
    y: 189.13,
    width: 84.21,
    height: 69.1,
    style: {
      fill: "rgb(15,152,247)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.17,
    y: 189.13,
    width: 84.21,
    height: 69.1,
    style: {
      fillOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.17,
    y: 189.13,
    width: 84.21,
    height: 69.1,
    style: {
      fill: "none",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.34,
    y: 189.13,
    width: 84.21,
    height: 69.1,
    style: {
      fill: "rgb(15,152,247)",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,281.49C366.55,277.21 355.38,258.23 355.38,258.23L337.56,258.23L346.73,281.49L369.25,281.49Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.25,281.49C366.55,277.21 355.38,258.23 355.38,258.23L337.56,258.23L346.73,281.49L369.25,281.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.25,281.49C366.55,277.21 355.38,258.23 355.38,258.23L337.56,258.23L346.73,281.49L369.25,281.49Z",
    style: {
      fillOpacity: 0.2,
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M369.25,281.49C366.55,277.21 355.38,258.23 355.38,258.23L337.56,258.23L346.73,281.49L369.25,281.49Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.42,281.49C242.12,277.21 253.28,258.23 253.28,258.23L271.11,258.23L261.94,281.49L239.42,281.49Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.28,258.23L245.53,281.49L333.48,281.49L337.56,258.23L253.28,258.23Z",
    style: {
      fill: "rgb(15,152,247)",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.22,214.13L366.22,237.27",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,224.14L370.6,242.9",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.29,237.27L244.29,251.65",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.54,245.4L240.54,256.65",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.93,206.1C181.914,209.48 185.378,212.404 189.21,214.78C195.21,218.37 217.21,230.84 218.94,231.54C220.67,232.24 273.21,223.66 273.21,223.66C273.21,223.66 276.21,225.06 278.1,226.25C279.99,227.44 291.97,231.25 291.97,231.25C291.97,231.25 292.77,230.85 291.87,230.16C290.97,229.47 285.19,226.66 285.19,226.66L297.19,229.26C297.19,229.26 297.89,228.76 297.59,228.26C297.29,227.76 286.59,223.67 286.59,223.67L298.59,224.27C298.59,224.27 299.49,223.17 298.89,222.77C298.29,222.37 286,219.57 286,219.57C286,219.57 299.07,218.47 299.17,217.97C299.27,217.47 299.67,216.88 298.87,216.78C298.07,216.68 281.71,215.08 281.71,215.08C281.71,215.08 286,212.39 286.5,211.59C287,210.79 287.7,209.19 286.9,209.19C286.1,209.19 285.9,209.69 284.81,210.39C283.72,211.09 279.42,212.79 278.22,213.78C277.02,214.77 273.43,217.38 273.43,217.38L225.35,217.48L195.5,193.93",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.85,216.78C298.06,216.68 281.69,215.08 281.69,215.08C281.69,215.08 285.98,212.39 286.48,211.59C286.98,210.79 287.68,209.19 286.88,209.19C286.08,209.19 285.88,209.69 284.79,210.39C283.7,211.09 279.4,212.79 278.2,213.78C277,214.77 273.41,217.38 273.41,217.38L225.33,217.48L220,213.25C218,216.76 214.26,223.34 211.83,227.68C215.57,229.76 218.4,231.31 218.97,231.54C220.67,232.24 273.24,223.66 273.24,223.66C273.24,223.66 276.24,225.06 278.13,226.25C280.02,227.44 292,231.25 292,231.25C292,231.25 292.8,230.85 291.9,230.16C291,229.47 285.22,226.66 285.22,226.66L297.22,229.26C297.22,229.26 297.92,228.76 297.62,228.26C297.32,227.76 286.62,223.67 286.62,223.67L298.62,224.27C298.62,224.27 299.52,223.17 298.92,222.77C298.32,222.37 286,219.57 286,219.57C286,219.57 299.07,218.47 299.17,217.97C299.27,217.47 299.65,216.88 298.85,216.78Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,155.92C218.611,155.59 219.017,155.399 219.444,155.399C220.112,155.399 220.696,155.868 220.84,156.52C221.177,158.711 220.598,160.948 219.24,162.7C218.14,163.8 217.14,164.1 217.14,162.7C217.418,160.42 217.818,158.157 218.34,155.92Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.06,138.44C205.709,143.305 203.626,147.888 200.19,151.35C196.988,154.499 193.367,157.191 189.43,159.35C185.493,161.509 190.01,162.48 191.19,163.46C192.37,164.44 194.71,164.25 194.71,164.25C196.07,167.969 198.283,171.319 201.17,174.03C205.86,178.33 211.34,177.94 214.47,171.49C217.6,165.04 219.17,158.57 218.78,154.85L218.39,151.13C218.39,151.13 208.21,145.48 206.06,138.44Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.47,
    cy: 156.18,
    rx: 0.9,
    ry: 1.6,
    style: {
      fill: "rgb(38,50,56)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.36,
    cy: 168.95,
    rx: 0.9,
    ry: 1.6,
    style: {
      fill: "rgb(38,50,56)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.15,
    cy: 156.18,
    rx: 0.9,
    ry: 1.6,
    style: {
      fill: "rgb(38,50,56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.35,154.48C212.006,155.678 211.904,156.932 212.05,158.17C212.35,159.87 213.75,162.76 212.55,163.26C211.435,163.768 210.126,163.614 209.16,162.86",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.87,153.29C202.87,153.29 203.35,150.23 207.36,150.58",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,151.52C213.61,151.52 217.35,148.52 218.56,154.01",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(38,50,56)",
      strokeWidth: 1
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/empty-box.53a62bc40cf8f7fe1b1118688cff68fc.svg";
export { ForwardRef as ReactComponent };